// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-5 {
  padding: 1rem 0.5rem 1rem 0.5rem !important;
}

.modal-title {
  margin: 0;
  color: #000000;
}

.modal-header {
  display: flex;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.modal-header .fa-times {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
